exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sections-container {\n  border: 12px solid #50aadb;\n}\n.scroll-enter-active, .scroll-leave-active {\n  -webkit-transition: \"swing\" .8s;\n  transition: \"swing\" .8s;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-12007656","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app.vue
// module id = 355
// module chunks = 0